var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar0(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "42px",
    height: "41px",
    viewBox: "0 0 42 41",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "star - 0") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter-1"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    type: "matrix",
    values: "0 0 0 0 0.964706 0 0 0 0 0.631373 0 0 0 0 0.113725 0 0 0 1.000000 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Learning-Activity---Progress---VD---Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter-1)",
    id: "star---0"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.5068425,11.6826913 L18.4623154,1.58622281 C19.500366,-0.528740937 22.499634,-0.528740937 23.5376846,1.58622281 L28.4931575,11.6826913 L39.5739318,13.3017353 C41.8950836,13.6408856 42.8219083,16.5091494 41.1423071,18.1554191 L33.1241835,26.0144238 L35.0170057,37.1115166 C35.4135058,39.4360867 32.9870471,41.2087712 30.9109458,40.1112581 L21,34.8719216 L11.0890542,40.1112581 C9.01295292,41.2087712 6.5864942,39.4360867 6.98299426,37.1115166 L8.87581648,26.0144238 L0.857692886,18.1554191 C-0.821908322,16.5091494 0.104916437,13.6408856 2.42606822,13.3017353 L13.5068425,11.6826913 Z M21,2.84557811 L15.3860898,14.2835718 L2.83300487,16.1177394 L11.9165024,25.0209759 L9.77217953,37.5925475 L21,31.6570565 L32.2278205,37.5925475 L30.0834976,25.0209759 L39.1669951,16.1177394 L26.6139102,14.2835718 L21,2.84557811 Z",
    id: "Combined-Shape",
    fill: "#383C40"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar0);
export default __webpack_public_path__ + "static/media/star-0.7719391c5bae056825d33284c011620b.svg";
export { ForwardRef as ReactComponent };